enum PRICE {
    NA = -1,
    SOLD_OUT = 0,
}

export default PRICE;
